/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileInviteFriendContainer_app$ref: FragmentReference;
export type ProfileInviteFriendContainer_app = {|
  +referralVcReward: ?number,
  +$refType: ProfileInviteFriendContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileInviteFriendContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "referralVcReward",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'efb97ecccfcd9534e199193f0016e9fa';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/ProfileInviteFriendContainer_app.graphql.js